import { render } from "./AddPictureMultiple.vue?vue&type=template&id=811d086c&scoped=true"
import script from "./AddPictureMultiple.vue?vue&type=script&lang=js"
export * from "./AddPictureMultiple.vue?vue&type=script&lang=js"

import "./AddPictureMultiple.vue?vue&type=style&index=0&id=811d086c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-811d086c"

export default script